module.exports = __webpack_public_path__ + "img/box-arrow-up.8ec931d9.svg";